module.exports = __webpack_public_path__ + "static/img/b3.71e97d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/b3.png
// module id = ejuT
// module chunks = 0